import type { SVGProps } from "react";

export function VideocamIcon(props: SVGProps<SVGSVGElement>) {
  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}>
      <path
        d="M5.25 3C3.45507 3 2 4.45507 2 6.25V12.75C2 14.5449 3.45507 16 5.25 16H7.49273C7.41399 16.8414 6.70578 17.5 5.84375 17.5H3.25C2.83579 17.5 2.5 17.8358 2.5 18.25V21.25C2.5 21.6642 2.83579 22 3.25 22H6.25C9.42564 22 12 19.4256 12 16.25V16H13.75C15.4385 16 16.8262 14.7124 16.9849 13.0656L20.8641 15.3931C21.0958 15.5321 21.3844 15.5358 21.6195 15.4026C21.8547 15.2695 22 15.0202 22 14.75V4.25C22 3.9798 21.8547 3.73048 21.6195 3.59735C21.3844 3.46422 21.0958 3.46786 20.8641 3.60688L16.9849 5.93444C16.8262 4.28759 15.4385 3 13.75 3H5.25ZM17 7.67465L20.5 5.57464V13.4254L17 11.3254V7.67465ZM6.25 20.5H4V19H5.84375C7.53451 19 8.91476 17.6706 8.9962 16H10.5V16.25C10.5 18.5972 8.59721 20.5 6.25 20.5ZM3.5 6.25C3.5 5.2835 4.2835 4.5 5.25 4.5H13.75C14.7165 4.5 15.5 5.2835 15.5 6.25V12.75C15.5 13.7165 14.7165 14.5 13.75 14.5H5.25C4.2835 14.5 3.5 13.7165 3.5 12.75V6.25Z"
        fill="currentColor"
      />
    </svg>
  );
}
